<template>
  <div class="mb-1">
    <form method="post" :action="formUrl">
      <input type="hidden" name="_token" :value="this.$csrf_token">
      <input type="hidden" name="payment_method" :value="paymentMethod.id">

      <button v-if="!confirm" class="btn btn-link btn-sm" type="button" @click="confirm = true">
        Als Zahlungsmethode hinterlegen
      </button>

      <button v-if="confirm" class="btn btn-outline-primary btn-sm" type="submit">
        <i class="fal fa-check"></i>
        Bestätigen
      </button>
      <button v-if="confirm" class="btn btn-outline-dark btn-sm" type="button"
              @click="confirm = false">
        <i class="fal fa-times"></i>
        Abbrechen
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: "SetAsDefaultForm",

  props: {
    paymentMethod: {
      type: Object,
      required: true
    },
    formUrl: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      confirm: false
    }
  },
}
</script>

<style scoped>

</style>
